import React from 'react';
import { Card } from 'reactstrap';
import './css/CreatorCardWithPadding.css';
import { DEFAULT_USER_AVATAR, ROLE } from '../../shared/constants/common';
import LazyImage from '../../components/LazyImage/LazyImage';
import ViewProfileButton from '../buttons/ViewProfileButton';
import FollowPPVCreatorButton from '../buttons/FollowPPVCreatorButton';
import { getSubscriptionPriceWithExtraCharge } from '../../shared/utils/paymentUtil';
import { getSubscriptionDateText } from '../../shared/utils/function';
import { truncateUsernameDisplay } from '../../shared/utils/usernameFormat';

const CreatorCardWithPadding = ({
  creator,
  vatPercentage = 0,
  tab = null,
  onFollowSuccess,
  onUnfollowSuccess,
}) => {
  const isFollowing = creator.isFollowing ?? false;
  const isSubscribed = creator.isSubscribed ?? false;
  const userAppliedPromotion =
    creator?.applied_promotion && Object.keys(creator.applied_promotion).length > 0
      ? creator.applied_promotion
      : null;
  const hasAppliedPromotion = !!userAppliedPromotion;

  const avatarSrc = creator.avatar || creator.profile_picture || DEFAULT_USER_AVATAR;
  const showSubscriptionDate = tab && isSubscribed && creator?.expire_at;
  const priceDisplay = creator?.price
    ? getSubscriptionPriceWithExtraCharge(creator.price, creator?.active_promotion, vatPercentage)
    : '$0.00';
  const isFeature = creator.isFeature || false;

  return (
    <div className={`creator-col`}>
      <Card className={`creator-card with_discover_page ${isFeature ? 'is_trending' : ''}`}>
        <LazyImage
          src={avatarSrc}
          alt="Creator Avatar"
          className="creator-card-avatar"
          onError={(e) => {
            e.target.src = DEFAULT_USER_AVATAR;
          }}
        />
        {(isFeature) && (
          <div className='show_bage_wrap'>
            <i className="fa fa-star"></i>
          </div>
        )}
        <h3 className="creator-card-username">{truncateUsernameDisplay(creator.username)}</h3>

        {/* {creator.price && (
          <div className="creator-card-price">
            <span>{creator?.price ? 
            `${getSubscriptionPriceWithExtraCharge(creator.price, creator?.active_promotion, vatPercentage)}` 
            : '$0.00'}</span>
          </div>
        )} */}
        {creator.rol === ROLE.CREATOR_SUB && (
          <div className="creator-card-price">
            {showSubscriptionDate ? (
              getSubscriptionDateText(creator.expire_at, creator.state, tab, hasAppliedPromotion)
            ) : (
              <span>{priceDisplay}</span>
            )}
          </div>
        )}

        {creator.rol === ROLE.CREATOR_CONTENT && (
          <FollowPPVCreatorButton
            creator={creator}
            onFollowSuccess={onFollowSuccess}
            onUnfollowSuccess={onUnfollowSuccess}
          >
            <button className={`follow-btn ${isFollowing ? 'following' : ''}`}>
              {isFollowing ? 'Following' : 'Follow'}
            </button>
          </FollowPPVCreatorButton>
        )}

        <ViewProfileButton creator={creator}>
          <button className={`mt-auto cm_outline_primary ${isFollowing ? 'following' : ''}`}>
            View Profile
          </button>
        </ViewProfileButton>
      </Card>
    </div>
  );
};

export default CreatorCardWithPadding;
